import { billingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import { checkoutBlockTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(billingAddressStyles, {
    headingText: {
        variant: "h3",
        css: css`
            ${checkoutBlockTitleStyles()}
        `,
    },
    selectSavedAddressLink: {
        css: css`
            display: none; // Pour cacher le button edit
        `,
    },
    addressDisplayAndFormGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            padding-top: 0;
        `,
    },
});
